import { c as _c } from "react/compiler-runtime";
import { Typography, Stack } from '@mui/material';
import type { PropsWithChildren } from 'react';
export const NumericBulletSection = t0 => {
  const $ = _c(12);
  const {
    bulletNumber,
    title,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "24px",
      alignItems: "start"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `${bulletNumber}.`;
  let t3;
  if ($[1] !== t2) {
    t3 = <Typography variant="h4">{t2}</Typography>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      width: "100%",
      gap: "40px"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== title) {
    t5 = <Typography variant="h4">{title}</Typography>;
    $[4] = title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children || $[7] !== t5) {
    t6 = <Stack sx={t4}>{t5}{children}</Stack>;
    $[6] = children;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t3 || $[10] !== t6) {
    t7 = <Stack direction="row" sx={t1}>{t3}{t6}</Stack>;
    $[9] = t3;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};